module.exports = __webpack_public_path__ + "img-char-Harper@2x.png";


//////////////////
// WEBPACK FOOTER
// ./app/features/dashboard/images/img-char-Harper@2x.png
// module id = 478
// module chunks = 0